import React from 'react';

const Footer = ({
  className,
  children,
  ...props
}) => {
  const classes = ['Footer'];
  classes.push(className);
  return <section className={classes.join(' ')} {...props}>
    {children}
  </section>;
};

export default Footer;
